// 没有登录 不能进入的路由
export const notLoginIsEnterRoute = () => ['/history', 'player'];

export const notLoginToRoute = '/';

export const AES_KEY = '4kqvNg8LyIe1WQTs';

export const H5_PREFIX = 'https://af.hkatv.vip';
